import { collection, query, where, getDocs, doc, updateDoc, increment } from 'firebase/firestore';
import { db } from '../lib/firebase';

export const getCouponByCode = async (code) => {
    try {
        const q = query(collection(db, 'coupons'), where('code', '==', code.toUpperCase()));
        const snapshot = await getDocs(q);
        if (snapshot.empty) return null;
        
        const docData = snapshot.docs[0];
        return { id: docData.id, ...docData.data() };
    } catch (error) {
        console.error("Error fetching coupon:", error);
        return null;
    }
};

export const incrementCouponUsage = async (couponId) => {
    try {
        const couponRef = doc(db, 'coupons', couponId);
        await updateDoc(couponRef, {
            usedCount: increment(1)
        });
    } catch (error) {
        console.error("Error updating coupon usage:", error);
    }
};
